import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { OrdersTable } from './components';
import { OrdersHeader } from './components';
import { OrdersFooter } from './components';
import { t } from '../../i18n';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  }
}));

const OrdersList = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <OrdersHeader/>
      <OrdersTable/>
      <OrdersFooter/>
      <div style={{color:'grey', marginTop:'15px'}}>
        <p>{t('ordersList.exchangeRateNotice')}</p>
        <p>{t('ordersList.workScheduleNotice')}</p>
        <p>{t('ordersList.quoteFluctuationNotice')}</p>
      </div>
    </div>
    
  );
};

export default OrdersList;

